import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import { collectionApi } from '@ui/api/collection';
import * as actions from '../actions';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const reload: Epic<any, any, any, EpicDependencies> = action$ =>
  action$.pipe(
    ofType(actions.RELOAD_ACTIONS.REQUESTED),

    switchMap(({ payload: { request, collections } }) => {
      return collectionApi
        .saveRequest(request, collections)
        .pipe(switchMap(() => of(actions.requestsRequested())));
    }),
  );



// WEBPACK FOOTER //
// ./src/scenes/Requests/services/epics/reload.ts